// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Fax from '../_raw/ui/icon_fax.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Fax);
